<template>
  <nav ref="nav" id="nav" class="nav"
       :class="{active:$Store.Public().scroll.y<=80||$Store.Public().scroll.dY==='top',nav_bg:$Store.Public().scroll.y>80}">
    <div class="container">
      <img class="logo" alt="logo"
           :src="file.ImageLogo">
      <div v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.XL)" class="button_menu"
           @click="$Store.Overseas().updateMenu({isOpen:!$Store.Overseas().menu.isOpen})">
        <MenuOutlined :class="!$Store.Overseas().menu.isOpen?'active':''" />
        <CloseOutlined :class="$Store.Overseas().menu.isOpen?'active':''" />
      </div>
      <div class="box_menu"
           :class="$Store.Overseas().menu.isOpen?'active':''"
           :style="{maxHeight:`${$Store.Public().height-60}px`}">
        <a-row justify="end">
          <a-col :xs="24" :xl="14">
            <a-menu :mode="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'horizontal':'inline'"
                    :inlineIndent="35" :subMenuCloseDelay="0.3" :selectable="false">
              <template v-for="item in expand.nav">
                <a-menu-item>
                  <a v-if="item.hash"
                     @click="$router.push({hash:item.hash})">
                    {{ item.name }}
                  </a>
                  <a v-if="item.href" target="_blank"
                     :href="item.href">
                    {{ item.name }}
                  </a>
                </a-menu-item>
              </template>
            </a-menu>
          </a-col>
          <a-col :xs="24" :xl="3">
            <div class="box_language">
              <a-dropdown placement="bottomRight" overlayClassName="box_dropdown"
                          :getPopupContainer="()=>$refs.nav">
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-for="item in $Enum.LanguageDict">
                      <a @click="$Store.Overseas().setLanguage(item.value)">
                        {{ item.label }}
                      </a>
                    </a-menu-item>
                  </a-menu>
                </template>
                <a-button type="link"
                          @click.prevent>
                  <GlobalOutlined />
                  <!--{{ $Enum.LanguageDict.find(v => v.value === $Store.Overseas().getLanguage()).label }}-->
                  {{ $Enum.LanguageDict.find(v => v.value === $Enum.LanguageEnum.EN).label }}
                  <DownOutlined />
                </a-button>
              </a-dropdown>
            </div>
          </a-col>
          <a-col :xs="24" :xl="4">
            <div class="box_button">
              <a-button type="link" target="_blank"
                        :href="href.github">
                <span class="iconfont icon-github" />
                GitHub
              </a-button>
              <a-button type="link" target="_blank"
                        @click="$router.push({hash:'#footer'})">
                Contact us
              </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" type="text/tsx">
import {
  MenuOutlined, CloseOutlined,
  GlobalOutlined, DownOutlined, CaretRightOutlined
} from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';
import { MenuEnum } from '@interface/page';
import ImageLogo from '@resource/image/public/logo_white_en.png';

export default {
  name: 'overseas_nav',
  components: {
    MenuOutlined,
    CloseOutlined,
    GlobalOutlined,
    DownOutlined,
    CaretRightOutlined
  },
  data(): DataInterface {
    return {
      enumType: {
        menu: MenuEnum
      },
      href: {
        github: 'https://github.com/galaxy-future/infrapilot',
        gitee: 'https://gitee.com/galaxy-future'
      },
      file: {
        ImageLogo
      },
      expand: {
        nav: [
          {
            name: 'Benefits',
            hash: '#worth'
          },
          {
            name: 'Engines',
            hash: '#engine'
          },
          {
            name: 'AI Application Platform',
            href: $Config.Href.store
          },
          {
            name: 'Products',
            hash: '#feature'
          },
          {
            name: 'About Us',
            hash: '#about'
          }
        ]
      }
    };
  },
  watch: {
    $route: {
      handler(newData: any, oldDate: any): void {
        $Store.Overseas().updateMenu({
          isOpen: false
        });
      }
    }
  },
  methods: {
    /**
     * 退出登录
     */
    logout(): void {
      $RQ.SSO.logout();
      
      $FN.Message('success', {
        content: $Enum.TextEnum.SuccessLogout
      });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}public/';
@height: 80px;

.nav {
  @style: background @time, opacity @time, transform @time;
  .position(fixed, 0, 0, auto, 0);
  z-index: 10;
  width: 100%;
  height: @height;
  padding: 0 @padding;
  background: fade(@color_black, 0);
  border-bottom: 1px solid fade(@color_white, 0);
  opacity: 0;
  .transform(translateY(-@height));
  .transition(@style);
  
  &.active {
    opacity: 1;
    .transform(translateY(0));
  }
  
  &.nav_bg {
    background: fade(@color_black, 70);
    border-bottom: 1px solid fade(@color_white, 20);
  }
  
  .container {
    position: relative;
    max-width: @grid_xl;
    height: 100%;
    margin: 0 auto;
  }
}

.logo {
  .position(left);
  height: 50%;
  margin: auto 0;
  .transition(transform @time);
}

.box_menu {
  overflow: hidden;
  position: relative;
  height: @height;
  
  &:deep(.ant-menu) {
    @p: 15px;
    display: inline-block;
    width: 100%;
    height: @height;
    background: none;
    border: none;
    
    .ant-menu-item,
    .ant-menu-submenu {
      padding: 0;
      
      &:hover,
      &.ant-menu-item-active,
      &.ant-menu-submenu-active {
        > .ant-menu-title-content,
        > .ant-menu-submenu-title > .ant-menu-title-content {
          > a {
            color: @color_processing !important;
            text-shadow: 0 0 1px @color_processing !important;
          }
        }
        
        > .ant-menu-submenu-arrow,
        > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
          &::before,
          &::after {
            color: @color_processing !important;
            text-shadow: 0 0 1px @color_processing !important;
          }
        }
      }
      
      &::after {
        left: @p;
        right: @p;
        .transition(border-color @time);
      }
    }
    
    .ant-menu-title-content {
      display: block;
      height: @height;
      
      a {
        @style: color @time text-shadow @time;
        display: block;
        position: relative;
        height: @height;
        padding: 0 @p;
        .font(center, @height, @color_white, @font_6);
        .transition(@style);
        
        &::before {
          display: none;
        }
      }
    }
    
    .anticon-ellipsis {
      .font(center, @height, fade(@color_white, 90), @font_6);
    }
  }
}

.box_button {
  position: relative;
  height: @height;
  
  a,
  .ant-btn {
    @bw: 90px;
    @bh: 34px;
    @style: color @time, opacity @time;
    .position();
    width: @bw;
    height: @bh;
    padding: 0;
    margin: auto;
    .transition(@style);
    border: 1px solid @color_white;
    border-radius: @bh*0.5;
    .borderBox();
    
    &:nth-child(1) {
      left: -@bw;
      border-radius: 5px 0 0 5px;
      border-right: 1px solid fade(@color_black, 10);
      background-color: transparent;
      .font(center, -1px+@bh, @color_white, @font_6);
    }
    
    &:nth-child(2) {
      right: -@bw;
      border-radius: 0 5px 5px 0;
      border-left: 1px solid fade(@color_black, 10);
      background-color: @color_white;
      .font(center, -1px+@bh, @color_6, @font_6);
    }
    
    &:hover {
      opacity: 0.8;
    }
    
    span {
      margin-right: 5px;
    }
  }
}

.box_language {
  position: relative;
  height: @height;
  text-align: center;
  
  span,
  .ant-btn:deep(span) {
    display: inline-block;
    .font(center, @height, @color_white, @font_6);
  }
  
  .ant-btn {
    height: auto;
    padding: 0;
    border: none;
    
    &.ant-dropdown-open {
      .anticon {
        &.anticon-down {
          &:deep(svg) {
            .transform(translateY(2px) scaleY(-1));
          }
        }
      }
    }
    
    &:hover {
      &:deep(span) {
        color: @color_processing;
      }
    }
    
    &:deep(span) {
      .transition(color @time);
    }
    
    .anticon {
      .font(center, @height, @color_white, @font_8);
      vertical-align: top;
      
      &:deep(svg) {
        .transform(translateY(2px));
      }
      
      &.anticon-down {
        margin: 0 0 0 3px;
        
        &:deep(svg) {
          .transform(translateY(2px));
          .transition(transform @time);
        }
      }
    }
  }
}

.button_menu {
  @ms: 40px;
  .position(right);
  width: @ms;
  height: @ms;
  margin: auto 0;
  background: fade(@color_black, 30);
  border: 1px solid fade(@color_white, 20);
  border-radius: 5px;
  cursor: pointer;
  .transition(opacity @time);
  
  &:hover {
    opacity: @opacity;
  }
  
  span {
    @as: 26px;
    .position();
    width: @ms;
    height: @ms;
    margin: auto;
    .font(center, @ms, fade(@color_white, 70), @as);
    opacity: 0;
    .transform(translateX(-1px));
    .transition(opacity @time);
    
    &.active {
      opacity: 1;
    }
    
    &:deep(svg) {
      display: block;
      .position();
      margin: auto;
    }
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  @height: 60px;
  
  .nav {
    height: @height;
    padding: 0 10px;
    background: fade(@color_black, 70);
    border-bottom: 1px solid fade(@color_white, 20);
    opacity: 1 !important;
    .transform(translateY(0)) !important;
  }
  
  .box_menu {
    @style: opacity @time, transform @time;
    @mh: 40px;
    overflow-x: hidden;
    overflow-y: auto;
    .position(absolute, @height, -10px, auto, -10px);
    width: calc(~'100% + 20px');
    height: auto;
    padding: 20px 0;
    background: fade(@color_black, 85);
    opacity: 0;
    .transform(translateX(100%));
    .transition(@style);
    pointer-events: none;
    
    &.active {
      opacity: 1;
      .transform(translateX(0));
      pointer-events: all;
    }
    
    &:deep(.ant-menu) {
      height: auto;
      
      .ant-menu-item,
      .ant-menu-submenu {
        padding: 0 !important;
        margin: 0;
        
        &::after {
          display: none;
        }
      }
      
      .ant-menu-title-content {
        height: @mh;
        
        a {
          height: @mh;
          padding: 0 0 0 20px;
          .font(left, @mh, @color_white, @font_6);
        }
        
        .anticon {
          .position(right, 20px);
          height: 14px;
          margin: auto 0;
          .transition(color 0s);
        }
      }
      
      .ant-menu-submenu-title {
        padding: 0 !important;
        margin: 0;
        
        .ant-menu-submenu-arrow {
          right: 20px;
          
          &::before,
          &::after {
            color: @color_white !important;
          }
        }
      }
      
      .ant-menu-sub {
        padding: 0 0 5px;
        background: fade(@color_black, 30);
        
        a {
          padding: 0 0 0 40px;
        }
        
        .ant-menu-sub {
          background: fade(@color_black, 60);
          
          a {
            padding: 0 0 0 60px;
          }
        }
      }
    }
  }
  
  .box_button {
    height: @height;
    margin-top: 10px;
    
    a,
    .ant-btn {
      width: calc(~'50% - 20px');
      
      &:nth-child(1) {
        left: 20px;
        right: auto;
      }
      
      &:nth-child(2) {
        left: auto;
        right: 20px;
      }
    }
  }
  
  .box_language {
    max-width: 200px;
    height: @height;
    margin: 0 auto;
    
    span,
    .ant-btn:deep(span) {
      line-height: @height !important;
    }
  }
}
</style>
<style lang="less" rel="stylesheet/less">
@import '@resource/css/_global.less';

.ant-menu-submenu-popup {
  > .ant-menu {
    background-color: fade(@color_black, 85) !important;
    border: 1px solid fade(@color_white, 20) !important;
    .borderBox() !important;
    
    .ant-menu-item,
    .ant-menu-submenu {
      padding: 0;
      margin: 0;
      
      &:hover,
      &.ant-menu-item-active,
      &.ant-menu-submenu-active {
        > .ant-menu-title-content,
        > .ant-menu-submenu-title > .ant-menu-title-content {
          > a {
            color: @color_processing !important;
            text-shadow: 0 0 1px @color_processing !important;
          }
        }
        
        > .ant-menu-submenu-arrow,
        > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
          &::before,
          &::after {
            color: @color_processing !important;
            text-shadow: 0 0 1px @color_processing !important;
          }
        }
      }
    }
    
    .ant-menu-title-content {
      display: block;
      height: 100%;
      
      a {
        @style: color @time text-shadow @time;
        display: block;
        position: relative;
        height: 100%;
        padding: 0 10px;
        color: fade(@color_white, 90);
        .transition(@style);
        
        &::before {
          display: none;
        }
      }
      
      .anticon {
        .position(right, 10px);
        height: 14px;
        margin: auto 0;
        .transition(color 0s);
      }
    }
    
    .ant-menu-submenu-title {
      padding: 0;
      margin: 0;
      
      .ant-menu-submenu-arrow {
        right: 10px;
        
        &::before,
        &::after {
          color: @color_white;
        }
      }
    }
  }
}

.box_dropdown {
  .ant-dropdown-menu {
    background-color: fade(@color_black, 85);
    border: 1px solid fade(@color_white, 20);
    .borderBox();
    
    .ant-dropdown-menu-item {
      min-width: 100px;
      color: fade(@color_white, 90);
      
      &:hover {
        color: @color_processing;
        background-color: fade(@color_black, 85);
      }
    }
  }
}
</style>